import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logoog.webp";
import { profileFetchData } from "../../redux/actions/commonAction";
import { searchValue } from "../../redux/actions/searchValue";
import HelperScript from "../../utils/helper";
import Login from "../pages/Login";
import "react-lazy-load-image-component/src/effects/blur.css";
import { FaPowerOff, FaSearch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ReactGA from "react-ga4";
import { CityFetchData } from "../../redux/actions/cityAction";
import { CityResultFetchData } from "../../redux/actions/cityResult";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";
import { searchModalCategoryResultFetchData } from "../../redux/actions/searchModalCategoryResult";

const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
  { code: "gu", label: "Gujarati" },
  { code: "mr", label: "Marathi" },
  { code: "bn", label: "Bengali" },
  { code: "te", label: "Telugu" },
  { code: "ta", label: "Tamil" },
  { code: "ur", label: "Urdu" },
];

const Header = (props) => {
  const [loginStateEnable, setLoginEnableState] = useState(false);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [login, setlogin] = useState("");
  const tithi = useSelector((state) => state?.TithiReducer);
  const menuList = useSelector((state) => state?.MenuReducer?.data);

  const showLoginModel = () => {
    ReactGA.send({
      hitType: "pageview",
      page: `/profile`,
      title: "profile",
    });
    setLoginEnableState(!loginStateEnable);
  };
  const showLocationModal = () => {
    ReactGA.send({
      hitType: "pageview",
      page: `/location`,
      title: "location",
    });
    setLocationModalOpen(!locationModalOpen);
  };
  const closeLocationModal = () => {
    setLocationModalOpen(false);
    // Reset selections when modal closes
    setActiveTabSam("samagra");
    setActiveTab("Metro");
    setPendingCityClick(null);
    setPendingMetroClick(null);
    pendingCityUrlRef.current = null;
    lastFetchedCityRef.current = null;
  };
  let navigate = useNavigate();

  let dispatch = useDispatch();
  var months = [
    "જાન્યુઆરી",
    "ફેબ્રુઆરી",
    "માર્ચ",
    "એપ્રિલ",
    "મે",
    "જૂન",
    "જુલાઈ",
    "ઓગસ્ટ",
    "સપ્ટેમ્બર",
    "ઓક્ટોબર",
    "નવેમ્બર",
    "ડિસેમ્બર",
  ];
  var now = new Date();
  var thisMonth = months[now.getMonth()];

  var newdate = new Date();
  var thisDate = newdate.getDate();

  var days = [
    "રવિવાર",
    "સોમવાર",
    "મંગળવાર",
    "બુધવાર",
    "ગુરૂવાર",
    "શુક્રવાર",
    "શનિવાર",
  ];
  var newday = new Date();
  var thisDay = days[newday.getDay()];

  var year = new Date();
  var thisYear = year.getFullYear();

  const pathhh = useLocation();
  // Full path (e.g., "/gujarat")
  const pathname = window.location.href;
  const slug = pathhh.pathname.startsWith("/")
    ? pathhh.pathname.slice(1)
    : pathhh.pathname;
  const page = slug === "" ? "home" : slug;
  // window.location.href==window.location.origin+'/'

  // useEffect(() => {
  //   // Condition: if path includes a long slug, probably an article
  //   const isArticleURL = pathhh.pathname.split("/").filter(Boolean).length > 2;
  //   const segments = pathname.split("/").filter(Boolean);
  //   // if (pathname?.includes("/epaper/")) {
  //   //   return;
  //   // } else if (
  //   //   pathname == window.location.origin ||
  //   //   pathname == window.location.origin + "/" ||
  //   //   pathname == window.location.origin + "/epaper"
  //   // ) {
  //   //   dispatch(AllViewCountActionFetchData(page));
  //   // } else {
  //   //   dispatch(IncrementPostViewsFetchData(page));
  //   // }

  //   if (pathname?.includes("/epaper/")) {
  //     return;
  //   } else if (
  //     pathname === window.location.origin ||
  //     pathname === window.location.origin + "/" ||
  //     pathname === window.location.origin + "/epaper" ||
  //     pathname.includes("search-content")
  //   ) {
  //     dispatch(AllViewCountActionFetchData(page));
  //   } else if (!isArticleURL) {
  //     dispatch(AllViewCountActionFetchData(page));
  //   } else {
  //     dispatch(IncrementPostViewsFetchData(page));
  //   }
  // }, [window.location.origin, page]);
  // commented location by kunal on 03-12-2025

  // useEffect(() => {
  //   const timerId = setTimeout(checklocation, 1000);
  //   return function cleanup() {
  //     clearInterval(timerId);
  //   };
  // }, []);

  const [inputSearchValue, setInputSearchValue] = useState("");
  // commented location by kunal on 03-12-2025

  // const checklocation = () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(successFunction, errorFunction);
  //   }
  // };

  // function successFunction(position) {
  //   const lat = position.coords.latitude;
  //   const long = position.coords.longitude;
  //   localStorage.setItem(
  //     "SandeshLocation",
  //     JSON.stringify({ lat: lat, long: long })
  //   );
  //   const locationCheck = document.getElementById("locationCheck");
  //   if (locationCheck) locationCheck.style.display = "none";
  // }

  // function errorFunction(err) {
  //   const locationCheck = document.getElementById("locationCheck");
  //   if (locationCheck) locationCheck.style.display = "none";
  // }
  const citiesName = useSelector((state) => state.CityReducer.data.data);
  const GMetro = useSelector(
    (state) => state?.HomeSecondaryReducer?.data?.Gujaratmetro
  );
  const GujaratMetro = useMemo(() => GMetro, [GMetro]);

  // Handle Dynamic Google Translate Script Injection
  useEffect(() => {
    if (!document.getElementById("google-translate-script")) {
      const addScript = document.createElement("script");
      addScript.id = "google-translate-script";
      addScript.setAttribute(
        "src",
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
      );
      document.body.appendChild(addScript);

      window.googleTranslateElementInit = () => {
        if (window.google && window.google.translate) {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: "gu",
              autoDisplay: false,
            },
            "google_translate_element"
          );
        }
      };
    }
  }, []);

  // Fetch cities data on component mount
  useEffect(() => {
    dispatch(CityFetchData());
  }, [dispatch]);

  // Get the Samagra API data and loading state from the Redux store
  const { data: samagraAPIData1, loading: cityResultLoading } = useSelector(
    (state) => state?.CityResultReducer
  );
  // Handle both array and object with data property
  const samagraAPIData = useMemo(() => {
    if (Array.isArray(samagraAPIData1)) {
      return samagraAPIData1;
    } else if (samagraAPIData1?.data && Array.isArray(samagraAPIData1.data)) {
      return samagraAPIData1.data;
    }
    return samagraAPIData1;
  }, [samagraAPIData1]);
  const { 21: assetbaseUrl } = useSelector(
    (state) => state?.SettingReducer?.data
  );
  const searchCategories = useSelector(
    (state) => state?.searchModalCategoryResultReducer?.data
  );

  // Transform flat category list to nested structure
  const getNestedCategories = (categories) => {
    if (!categories || !Array.isArray(categories)) return [];

    const categoryMap = {};
    const nested = [];

    // First pass: create map
    categories.forEach(cat => {
      categoryMap[cat.id] = { ...cat, children: [] };
    });

    // Second pass: build tree
    categories.forEach(cat => {
      if (cat.parent_id === null) {
        nested.push(categoryMap[cat.id]);
      } else if (categoryMap[cat.parent_id]) {
        categoryMap[cat.parent_id].children.push(categoryMap[cat.id]);
      }
    });

    return nested;
  };

  const nestedSearchCategories = getNestedCategories(searchCategories);
  const [activeTabSam, setActiveTabSam] = useState("samagra");
  const [icon, seticon] = useState();
  const [myLocation, setMyLocation] = useState(
    localStorage.getItem("SandeshLocation")
  );
  const [pendingCityClick, setPendingCityClick] = useState(null);
  const [pendingMetroClick, setPendingMetroClick] = useState(null);
  const pendingCityUrlRef = useRef(null);
  const lastFetchedCityRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Metro");
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (name) => {
    setOpenMenu((prev) => (prev === name ? null : name));
  };
  const rightScroll = useCallback((event) => {
    const conent = document.querySelector("#content-sam-home");
    conent.scrollLeft += 100;
    event.preventDefault();
  }, []);
  const [apiData, setapiData] = useState([]);
  // Fetch the metro data
  useEffect(() => {
    async function fetchData() {
      const myMetroData = await Get(HttpService.metro);
      setapiData(Object.entries(myMetroData?.data));
    }
    fetchData();
  }, []);
  // Handle city click - set pending navigation and trigger data fetch
  const handleCityClick = useCallback((city) => {
    ReactGA.event({
      category: "Homepage",
      action: "Gujarat Samagra City Click",
      label: city?.name,
    });

    // Clear previous pending click to prevent race condition
    setPendingCityClick(null);
    setPendingMetroClick(null);
    // Reset last fetched city to ensure we wait for new data
    lastFetchedCityRef.current = null;
    // Set new pending city click to navigate after data loads
    setPendingCityClick(city);
    // Track which city URL we're waiting for
    pendingCityUrlRef.current = city?.url;
    // Set active tab to trigger data fetch
    setActiveTabSam(city?.url);
  }, []);

  const { 28: Facebook } = useSelector((state) => state?.SettingReducer?.data);
  const { 29: Twitter } = useSelector((state) => state?.SettingReducer?.data);
  const { 30: Instagram } = useSelector((state) => state?.SettingReducer?.data);
  const { 31: Youtube } = useSelector((state) => state?.SettingReducer?.data);
  const { 24: Android } = useSelector((state) => state?.SettingReducer?.data);
  const { 25: Apple } = useSelector((state) => state?.SettingReducer?.data);
  // Handle metro city click - navigate to first post directly
  const handleMetroClick = useCallback(
    (metro) => {
      ReactGA.event({
        category: "Homepage",
        action: "Gujarat Metro City Click",
        label: metro?.name,
      });

      // Clear previous pending clicks
      setPendingCityClick(null);
      setPendingMetroClick(null);

      // Find the metro data
      if (GujaratMetro && GujaratMetro.length > 0) {
        const metroData = GujaratMetro.find((el) => el?.name === metro?.name);
        if (metroData && metroData?.data && metroData.data.length > 0) {
          // Navigate to first post
          navigate(metroData.data[0]?.url);
          closeLocationModal();
        }
      }
    },
    [GujaratMetro, navigate]
  );

  // Navigate when data is loaded after city click
  useEffect(() => {
    // Only navigate if:
    // 1. There's a pending city click
    // 2. Data exists and has items (handle both array and object)
    // 3. The activeTabSam matches the pending city (data is for the correct city)
    // 4. The pending city URL ref matches (ensures we're waiting for this city)
    // 5. The last fetched city matches the pending city (ensures data is for current city)
    const isValidData =
      Array.isArray(samagraAPIData) && samagraAPIData.length > 0;
    const isDataForCurrentCity =
      lastFetchedCityRef.current === pendingCityClick?.url;

    if (
      pendingCityClick &&
      isValidData &&
      activeTabSam === pendingCityClick?.url &&
      pendingCityUrlRef.current === pendingCityClick?.url &&
      isDataForCurrentCity
    ) {
      // Small delay to ensure data is fully loaded
      const timer = setTimeout(() => {
        // Navigate to first article URL
        const articleUrl = samagraAPIData[0]?.url;
        if (articleUrl) {
          navigate(articleUrl);
          closeLocationModal();
          setPendingCityClick(null);
          pendingCityUrlRef.current = null;
          lastFetchedCityRef.current = null;
        } else {
        }
      }, 100);

      return () => clearTimeout(timer);
    } else if (pendingCityClick) {
    }
  }, [samagraAPIData, pendingCityClick, activeTabSam, navigate]);

  // Fetch city result data when a city is selected
  useEffect(() => {
    if (activeTabSam && locationModalOpen) {
      const timer = setTimeout(() => {
        let customLocation = "";
        if (myLocation) {
          const parseData = JSON.parse(myLocation);
          customLocation = "?lat=" + parseData.lat + "&long=" + parseData.long;
        }
        // Track which city we're fetching
        lastFetchedCityRef.current = activeTabSam;
        dispatch(CityResultFetchData(activeTabSam + customLocation));
      }, 300);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [activeTabSam, myLocation, locationModalOpen, dispatch]);

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(searchValue(inputSearchValue));
      if (inputSearchValue) {
        setShowSearchModal(false);
        navigate("/search");
        // navigate(`/search/${encodeURIComponent(inputSearchValue)}`);
      }
    }, 3000);
    return () => {
      clearInterval(timer);
    };
  }, [inputSearchValue, dispatch, navigate]);

  const Logout = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("access_token");
    localStorage.removeItem("userID");
    localStorage.removeItem("socialLogin");
    setUserName("");
    setlogin("clear");
    if (window.location.pathname === "/profile") {
      navigate("/");
    } else {
      navigate(window.location.pathname);
    }
  };

  if (localStorage.getItem("access_token") !== null) {
    dispatch(profileFetchData()).then((res) => {
      if (res) {
        setUserName(res?.user_data?.name);
      } else {
        setUserName("");
      }
    });
  }

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      setlogin("success");
    } else {
      setlogin("clear");
    }
  });

  const success = (success) => {
    setlogin(success);
  };


  const [showSearch, setShowSearch] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);

  const closeSearchModal = () => {
    setShowSearchModal(false);
    setInputSearchValue("");
  };

  const isLoggedIn =
    login === "success" && localStorage.getItem("access_token");



  return (
    <>
      <div className="text-center">
        <div className="ad-section">
          <HelperScript addstyle={1} argSmall={164} argLarge={2} />
        </div>
      </div>
      <section className="header d-flex flex-row" style={{ backgroundColor: "#ffffff", maxWidth: "100vw" }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="topbar">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between">
                    <div className="topbar-time-desktop align-items-center flex-shrink-0" style={{ gap: "35px" }}>
                      <div className="time d-flex align-items-center" id="demo" style={{ whiteSpace: "nowrap" }}>
                        <span className="date-top-header" style={{ marginRight: "15px" }}>
                          {thisDay}, {thisDate} {thisMonth}, {thisYear}
                        </span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: tithi?.data?.text,
                          }}
                        />
                      </div>
                    </div>

                    <div className="rightbar d-flex align-items-center flex-grow-1 justify-content-between justify-content-lg-end w-100">
                      <a
                        href="/epaper"
                        target="_blank"
                        className="e-paper-header"
                        style={{ marginRight: "12px" }}
                      >
                        <i className="far fa-newspaper" style={{ marginRight: "5px" }}></i>E-PAPER
                      </a>
                      <a
                        href="/epaper"
                        target="_blank"
                        className="e-paper-header_desktop"
                        style={{ marginRight: "15px" }}
                      >
                        <i className="far fa-newspaper" style={{ marginRight: "5px" }}></i>E-PAPER
                      </a>

                      {/* Global Override for Google Translate Banner */}
                      <style>
                        {`
                          body { top: 0 !important; position: static !important; }
                          .skiptranslate iframe, .goog-te-banner-frame { display: none !important; }
                          .goog-text-highlight { background-color: transparent !important; box-shadow: none !important; }
                          /* Ensure the translate dropdown has a clean white background, no red inherited */
                          #google_translate_element .goog-te-menu-value { color: #333; }
                          #google_translate_element { margin-right: 15px; display: flex; align-items: center; }
                        `}
                      </style>

                      {/* Hidden Google Translate Component Container */}
                      <div id="google_translate_element" style={{ width: 0, height: 0, overflow: "hidden", position: "absolute", visibility: "hidden" }}></div>

                      {/* Custom FA Globe Translate Dropdown (Matches Sandesh Theme Dropdowns) */}
                      {menuList &&
                        Object.values(menuList)
                          .filter((els) => els?.name === "Supplement")
                          .map((els, idx) => (
                            <li
                              key={idx}
                              className="sup-dd-wrapper me-3"
                              onMouseEnter={() => setOpenMenu(els?.name)}
                              onMouseLeave={() => setOpenMenu(null)}
                            >
                              {/* Main menu */}
                              <div className="sup-dd-trigger" title={els?.title}>
                                <Link
                                  target="_parent"
                                  className="sup-dd-link"
                                  to={`/${els?.category}`}
                                >
                                  {els?.name}
                                </Link>
                                <i className="fas fa-sort-down sup-dd-icon"></i>
                              </div>

                              {/* Dropdown */}
                              <ul
                                className={`sup-dd-menu ${openMenu === els?.name ? "sup-dd-show" : ""
                                  }`}
                              >
                                {Object.values(els?.submenu).map((sub, i) => (
                                  <li key={i} className="sup-dd-item">
                                    <Link
                                      className="sup-dd-item-link"
                                      title={sub?.title}
                                      to={`/${sub?.category}`}
                                      style={{ fontSize: "15px" }}
                                    >
                                      {sub?.name}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          ))}


                      <ul className="d-flex align-items-center list-unstyled mb-0" style={{ gap: "5px" }}>
                        {/* <li>
                        <a
                          href="/epaper"
                          target="_blank"
                          className="e-paper-header_desktop"
                        >
                          E-PAPER
                        </a>
                      </li> */}
                        <li
                          className="notranslate d-lg-none"
                          translate="no"
                          onClick={(e) => { e.stopPropagation(); setOpenMenu(openMenu === 'translate' ? null : 'translate'); }}
                          style={{ position: "relative", cursor: "pointer", alignItems: "center" }}
                        >
                          <img className="translate-icon-mobile" src="https://epapercdn.sandesh.com/images/2026/07/10/UuVlWY6Dck6Ibzc5pSKlAw15OkDO9qc9fkt5YTwX.webp" title="Select Language" alt="Select Language" style={{ height: "21px", width: "auto", objectFit: "contain", marginTop: "2px", paddingTop: "5px" }} />
                          <ul className={`sup-dd-menu force-absolute-dropdown ${openMenu === 'translate' ? "sup-dd-show" : ""}`} style={{ zIndex: 9999999999, minWidth: "120px", top: "100%", right: 0, left: "auto", maxHeight: "115px", overflowY: "auto", backgroundColor: "#fff", boxShadow: "0 4px 6px rgba(0,0,0,0.1)", border: "1px solid #ddd", scrollbarWidth: "thin" }}>
                            {SUPPORTED_LANGUAGES.map((lang) => (
                              <li key={lang.code} className="sup-dd-item">
                                <a href="javascript:void(0)" className="sup-dd-item-link" onClick={(e) => { e.preventDefault(); e.stopPropagation(); const select = document.querySelector('.goog-te-combo'); if (select) { select.value = lang.code; select.dispatchEvent(new Event('change', { bubbles: true, cancelable: true })); setOpenMenu(null); } else { document.cookie = `googtrans=/gu/${lang.code}; path=/;`; window.location.reload(); } }}>{lang.label}</a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="mobile-only-star-icon">
                          <style>
                            {`
                            @keyframes header-sparkle {
                              0% { transform: scale(0.9) rotate(-5deg); opacity: 0.8; }
                              100% { transform: scale(1.15) rotate(5deg); opacity: 1; }
                            }
                            @media (min-width: 992px) {
                              .mobile-only-star-icon {
                                display: none !important;
                              }
                            }
                          `}
                          </style>

                          <Link
                            to="/for-you"
                            title="For You"
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              color: "inherit"
                            }}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ margin: "0 5px", animation: "header-sparkle 1.8s ease-in-out infinite alternate" }}>
                              <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                              <path d="M20 3v4" />
                              <path d="M22 5h-4" />
                              <path d="M4 17v2" />
                              <path d="M5 18H3" />
                            </svg>
                          </Link>
                        </li>
                        <li
                          className="custom-translate-dropdown me-2 notranslate d-none d-lg-flex"
                          translate="no"
                          onClick={(e) => { e.stopPropagation(); setOpenMenu(openMenu === 'translate' ? null : 'translate'); }}
                          style={{ position: "relative", alignItems: "center", cursor: "pointer", listStyle: "none" }}
                        >
                          <style>
                            {`
                            .translate-text-desktop { 
                              display: inline-flex; 
                              align-items: center;
                              font-size: 14px;
                              font-weight: 600;
                              color: #fff !important;
                              background-color: #ae0a0b;
                              padding: 6px 12px;
                              border-radius: 25px;
                              text-transform: uppercase;
                              transition: all 0.2s ease-in-out;
                              font-family: inherit;
                              box-shadow: rgba(185, 0, 0, 0.2) 0px 4px 8px;
                            }
                            .translate-text-desktop:hover {
                              background-color: #900809;
                              box-shadow: rgba(185, 0, 0, 0.3) 0px 6px 12px;
                              transform: translateY(-1px);
                            } 
                            @media (max-width: 991px) {
                              .translate-text-desktop { 
                                display: none !important; 
                              }
                            }
                            
                            /* Nuke Google Translate Native Layout Shifts & Overlays */
                            .goog-te-banner-frame.skiptranslate,
                            .goog-te-balloon-frame,
                            #goog-gt-tt, .goog-te-menu-frame {
                              display: none !important;
                              opacity: 0 !important;
                              visibility: hidden !important;
                              height: 0 !important;
                              width: 0 !important;
                            }
                            .goog-text-highlight {
                              background-color: transparent !important;
                              box-shadow: none !important;
                            }
                            body {
                              top: 0 !important;
                            }

                            /* Ensure dropdowns never push flexbox containers */
                            .force-absolute-dropdown {
                              position: absolute !important;
                              margin-top: 10px !important;
                            }

                            /* Dropdown item links color */
                            .sup-dd-item-link {
                              color: #000 !important;
                            }
                          `}
                          </style>
                          <div style={{ cursor: "pointer", display: "flex", alignItems: "center", padding: "0 5px" }} title="Select Language">
                            <span className="translate-text-desktop">
                              <i className="fas fa-globe" style={{ marginRight: "6px", fontSize: "14px" }}></i>
                              LANGUAGE
                              <i className="fas fa-sort-down" style={{ marginLeft: "6px", marginBottom: "4px", fontSize: "12px" }}></i>
                            </span>
                          </div>
                          <ul className={`sup-dd-menu ${openMenu === 'translate' ? "sup-dd-show" : ""}`} style={{ zIndex: 9999999999, minWidth: "120px", top: "100%", right: 0, left: "auto", maxHeight: "115px", overflowY: "auto", backgroundColor: "#fff", boxShadow: "0 4px 6px rgba(0,0,0,0.1)", border: "1px solid #ddd", scrollbarWidth: "thin" }}>
                            {SUPPORTED_LANGUAGES.map((lang) => (
                              <li key={lang.code} className="sup-dd-item">
                                <a
                                  href="javascript:void(0)"
                                  className="sup-dd-item-link"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const select = document.querySelector('.goog-te-combo');
                                    if (select) {
                                      select.value = lang.code;
                                      select.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
                                      setOpenMenu(null);
                                    } else {
                                      document.cookie = `googtrans=/gu/${lang.code}; path=/;`;
                                      window.location.reload();
                                    }
                                  }}
                                >
                                  {lang.label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        {isLoggedIn ? (
                          <>
                            <li>
                              <Link
                                to="/profile"
                                className="signin cursor-pointer"
                              >
                                <i
                                  style={{
                                    fontSize: "18px",
                                    padding: "0 5px",
                                    cursor: "pointer",
                                  }}
                                  className=" fas fa-user"
                                  alt="profile"
                                  title="profile"
                                ></i>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/profile"
                                className="signin cursor-pointer"
                                alt="profile"
                                title="profile"
                              >
                                Hi, {userName?.split(" ")[0] || "There"}
                              </Link>
                            </li>
                            <li>
                              <FaPowerOff
                                onClick={Logout}
                              // style={{
                              //   fontSize: "18px",
                              //   padding: "9px",
                              //   cursor: "pointer",
                              // }}
                              />
                            </li>
                          </>
                        ) : (
                          <li>
                            <a
                              onClick={showLoginModel}
                              className="signin cursor-pointer"
                            >
                              <i
                                style={{
                                  fontSize: "18px",
                                  padding: "0 5px",
                                  cursor: "pointer",
                                }}
                                className=" fas fa-user"
                              ></i>
                            </a>
                          </li>
                        )}

                        <li>
                          <a
                            className=""
                            href="javascript:void(0)"
                            alt="Location"
                            title="Location"
                            onClick={showLocationModal}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <i
                              style={{
                                fontSize: "18px",
                                padding: "0 5px",
                                cursor: "pointer",
                              }}
                              className="fas fa-map-marker-alt"
                              alt="Location"
                              title="Location"
                            ></i>
                          </a>
                        </li>

                        <li>
                          <div className="d-flex">
                            <FaSearch
                              onClick={() => {
                                setShowSearchModal(true);
                                dispatch(searchModalCategoryResultFetchData());
                                ReactGA.send({
                                  hitType: "pageview",
                                  page: `/sandesh/search`,
                                  title: "search",
                                });
                              }}
                              style={{ cursor: "pointer", marginLeft: "10px" }}
                              alt="Search"
                              title="Search"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="logo">
            <div className="container">
              <div className="row">
                <div className="col-md-3">
                  {window.location.pathname === "/" ? (
                    <a href="/" className="brand" title="Sandesh Gujarati News">
                      {/* <LazyLoadImage
                    
                    src={logo}
                    style={{ filter: "none", width: "263px" }}
                  /> */}
                      <link rel="preload" href={logo} as="image" />

                      {/* Logo image with best practices */}
                      <img
                        src={"https://epapercdn.sandesh.com/images/2026/07/10/IElYr4bsz5CgVJk8K5dZjVExQviQ1jTIJX118pjp.webp"}
                        alt="Brand Logo"
                        title="Sandesh Gujarati news"
                        width="263"
                        height="auto"
                        fetchpriority="high" // Ensures the image is fetched first
                        loading="eager" // Ensures eager loading of the image
                        decoding="async" // Decodes the image asynchronously to avoid blocking rendering
                      />
                    </a>
                  ) : (
                    <a href="/" className="brand" title="Sandesh Gujarati News">
                      {/* <LazyLoadImage
                    
                    src={logo}
                    style={{ filter: "none", width: "263px" }}
                  /> */}
                      <link rel="preload" href={logo} as="image" />

                      {/* Logo image with best practices */}
                      <img
                        src={"https://epapercdn.sandesh.com/images/2026/07/10/IElYr4bsz5CgVJk8K5dZjVExQviQ1jTIJX118pjp.webp"}
                        alt="Brand Logo"
                        title="Sandesh Gujarati news"
                        width="263"
                        height="auto"
                        fetchpriority="high" // Ensures the image is fetched first
                        loading="eager" // Ensures eager loading of the image
                        decoding="async" // Decodes the image asynchronously to avoid blocking rendering
                      />
                    </a>
                  )}
                </div>
                <div className="col-md-9">
                  <div className="row">
                    <div
                      className="col-md-9 ad-section d-flex align-items-center"
                      style={{ marginRight: "auto", marginLeft: "-23px" }}
                    >
                      <HelperScript
                        argSmall={165}
                        argLarge={3}
                        key={window.location.pathname}
                      />
                    </div>
                    <div className="col-md-3 d-flex align-items-center justify-content-end" style={{ paddingRight: "25px" }}>
                      <div className="qr-code-app d-flex flex-column align-items-center justify-content-center text-center" style={{ gap: "4px" }}>
                        <a href="/d" target="_blank" style={{ display: "flex", justifyContent: "center" }}>
                          <img
                            loading="lazy"
                            src={"https://epapercdn.sandesh.com/images/2026/07/10/Hi9dFd9N6bu4c9VLDuptXUrfgrWr4qACeYAghQ5f.webp"}
                            alt="QR Code"
                            title="QR Code"
                            style={{ height: "70px" }}
                          />
                        </a>
                        <a href="/d" target="_blank" style={{ textDecoration: "none", color: "#ae0a0b", fontWeight: "bold", fontSize: "11px" }}>
                          <span style={{ whiteSpace: "nowrap" }}>Download App</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> {/* closing flex: 1 minWidth: 0 wrapper */}

        {/* True Grid Flex-box Sidebar */}
        <div
          className="d-none d-lg-flex flex-column align-items-center justify-content-center"
          style={{
            width: "50px",
            flexShrink: 0,
            backgroundColor: "#ffffff",
            borderLeft: "1px solid #ae0a0b", // Custom Red Border
            zIndex: 10,
          }}
        >
          <ul
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              listStyle: "none",
              margin: 0,
              padding: 0,
            }}
          >
            {[
              {
                label: "Whatsapp",
                href: "https://whatsapp.com/channel/0029VaAaSUK4Y9lvPf9RhB2l",
                icon: "fab fa-whatsapp",
                hoverColor: "#25D366"
              },
              {
                label: "Facebook",
                href: Facebook?.value,
                icon: "fab fa-facebook",
                hoverColor: "#1877F2"
              },
              {
                label: "Twitter",
                href: Twitter?.value,
                isXIcon: true,
                hoverColor: "#1DA1F2"
              },
              {
                label: "Instagram",
                href: Instagram?.value,
                icon: "fab fa-instagram",
                hoverColor: "#E4405F"
              },
              {
                label: "Youtube",
                href: Youtube?.value,
                icon: "fab fa-youtube",
                hoverColor: "#FF0000"
              },
            ].map((item, idx) => (
              <li key={idx}>
                <a
                  target="_blank"
                  title={item.label}
                  alt={item.label}
                  onClickCapture={() =>
                    ReactGA.event({
                      category: "Header",
                      action: "Icon",
                      label: item.label,
                    })
                  }
                  href={item.href}
                  rel="noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000000",
                    textDecoration: "none",
                    transition: "color 0.2s ease-in-out",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = item.hoverColor;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = "#000000";
                  }}
                >
                  {item.isXIcon ? (
                    <FaXTwitter size={20} />
                  ) : (
                    <i className={item.icon} title={item.label}
                      alt={item.label} style={{ fontSize: "20px" }}></i>
                  )}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {loginStateEnable && <Login success={success} />}

      {locationModalOpen && (
        <div className="location-modal-overlay" onClick={closeLocationModal}>
          <div
            className="location-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeLocationModal}
              className="location-modal-close-btn"
            >
              ×
            </button>

            {/* Title */}
            <h2 className="location-modal-title">Get Latest Local News</h2>

            {/* Subtitle */}
            <p className="location-modal-subtitle">Select your location</p>

            {/* Red Separator Line */}
            <div className="location-modal-separator" />

            {/* METRO CITIES SECTION */}
            {apiData && apiData.length > 0 && (
              <>
                {/* <h3
                  style={{
                    marginTop: "0",
                    marginBottom: "15px",
                    color: "#8B0000",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  Metro Cities
                </h3> */}
                <div className="location-grid metro-grid">
                  {/* Metro tab */}

                  {apiData?.map((els, index) => (
                    <a
                      key={index}
                      className={`location-city-link ${activeTab === els[1]?.name ? "active" : ""
                        }`}
                      onClick={() => handleMetroClick(els[1])}
                    >
                      {els[1]?.name}
                    </a>
                  ))}
                </div>
              </>
            )}

            {/* REGULAR CITIES SECTION */}
            {/* <h3
              style={{
                marginTop: apiData && apiData.length > 0 ? "0" : "0",
                marginBottom: "15px",
                color: "#8B0000",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              Districts
            </h3> */}
            {/* CITY LIST - Grid Layout */}
            <div className="location-grid">
              {citiesName?.map((els, index) => (
                <a
                  key={index}
                  className={`location-city-link ${activeTabSam === els?.url ? "active" : ""
                    }`}
                  onClick={() => handleCityClick(els)}
                >
                  {els?.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}

      {showSearchModal && (
        <div className="search-full-modal-overlay">
          <div className="search-full-modal-topbar">
            <div className="search-full-modal-logo">
              <img src={"https://epapercdn.sandesh.com/images/2026/07/10/IElYr4bsz5CgVJk8K5dZjVExQviQ1jTIJX118pjp.webp"} alt="Sandesh" />
            </div>
            <div className="search-full-modal-input-wrapper">
              <input
                autoFocus
                value={inputSearchValue}
                onChange={(e) =>
                  setInputSearchValue(e.target.value.trimStart())
                }
                type="search"
                placeholder="Search..."
              />
              <i className="fas fa-search"></i>
            </div>
            <button
              className="search-full-modal-close"
              onClick={closeSearchModal}
            >
              ×
            </button>
          </div>

          <div className="search-full-modal-body">
            {nestedSearchCategories && nestedSearchCategories.length > 0 && (
              <div className="search-full-modal-grid">
                {nestedSearchCategories.map((mainCat, idx) => (
                  <div key={idx} className="search-full-column">
                    <h4>
                      <Link to={mainCat.url} onClick={closeSearchModal}>
                        {mainCat.name}
                      </Link>
                    </h4>
                    {mainCat.children && mainCat.children.length > 0 && (
                      <ul>
                        {mainCat.children.map((subCat, subIdx) => (
                          <li key={subIdx}>
                            <Link to={subCat.url} onClick={closeSearchModal}>
                              {subCat.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Header;